<template>
  <sui-card class="state-card">
    <sui-card-content class="compact">
      <b>Containers</b>
    </sui-card-content>
    <sui-card-content>
      <sui-table definition unstackable compact basic="very">
        <sui-table-body>
          <sui-table-row>
            <sui-table-cell collapsing text-align="center">{{containersByStatus.ONLINE.length}}</sui-table-cell>
            <sui-table-cell>
              <i class="stop grey link icon" :class="{disabled: isStopOnlineDisabled}" title="Stop all" data-goal="HOST_PAGE_STOP_CONTAINERS" @click="stopOnline()" />
              Online
            </sui-table-cell>
          </sui-table-row>
          <sui-table-row>
            <sui-table-cell collapsing text-align="center">{{containersByStatus.OFFLINE.length}}</sui-table-cell>
            <sui-table-cell>
              <i class="play grey link icon" :class="{disabled: isStartOfflineDisabled}" title="Start all" data-goal="HOST_PAGE_START_CONTAINERS" @click="startOffline()" />
              Offline
            </sui-table-cell>
          </sui-table-row>
          <sui-table-row>
            <sui-table-cell collapsing text-align="center">{{containersByStatus.RESTARTING.length}}</sui-table-cell>
            <sui-table-cell>
              <i class="stop grey link icon" :class="{disabled: isStopRestartingDisabled}" title="Stop all" data-goal="HOST_PAGE_STOP_CONTAINERS" @click="stopRestarting()" />
              Restarting
            </sui-table-cell>
          </sui-table-row>
        </sui-table-body>
      </sui-table>
    </sui-card-content>
  </sui-card>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'HostContainersCard',
    props: {
      host: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['actionsById', 'containersByHost']),
      containersByStatus() {
        const containers = this.containersByHost[this.host.id]
        const containersByStatus = {ONLINE: [], OFFLINE: [], RESTARTING: []}
        for (const container of containers) {
          const key = container.status in containersByStatus ? container.status : 'OFFLINE'
          containersByStatus[key].push(container)
        }
        return containersByStatus
      },
      isHostOnline() {
        return this.host._isOnline
      },
      isStopOnlineDisabled() {
        return !this.isHostOnline || !this.containersByStatus.ONLINE.length || !this.containersByStatus.ONLINE.every(container => this.actionsById[container.service].serviceUpdate)
      },
      isStartOfflineDisabled() {
        return !this.isHostOnline || !this.containersByStatus.OFFLINE.length || !this.containersByStatus.OFFLINE.every(container => this.actionsById[container.service].serviceUpdate)
      },
      isStopRestartingDisabled() {
        return !this.isHostOnline || !this.containersByStatus.RESTARTING.length || !this.containersByStatus.RESTARTING.every(container => this.actionsById[container.service].serviceUpdate)
      },
    },
    methods: {
      stopOnline() {
        return this.$modals.confirm.open({
          text: 'You are going to stop all online containers on the host.',
          callback: () => {
            this.containersByStatus.ONLINE.map(container => {
              container.stop().catch(error => {
                this.$emit('error', error.message)
              })
            })
          },
        })
      },
      stopRestarting() {
        return this.$modals.confirm.open({
          text: 'You are going to stop all restarting containers on the host.',
          callback: () => {
            this.containersByStatus.RESTARTING.map(container => {
              container.stop().catch(error => {
                this.$emit('error', error.message)
              })
            })
          },
        })
      },
      startOffline() {
        return this.$modals.confirm.open({
          text: 'You are going to start all offline containers on the host.',
          callback: () => {
            this.containersByStatus.OFFLINE.map(container => {
              container.start().catch(error => {
                this.$emit('error', error.message)
              })
            })
          },
        })
      },
    },
  }
</script>

<style scoped>
  .content.content:nth-child(2) { padding: 0!important; justify-content: flex-start; }
  .table { margin: 0!important; height: 100%; }
  .center { padding: .4em 1em!important; }
  .link { float: right; margin-right: .7em; }
</style>
